import { createContext, useContext, useState } from 'react';
import React from 'react';

const HomeContext = createContext();

const HomeProvider = ({ children }) => {
  const [lotGridRows, setLotGridRows] = useState('');

  return (
    <HomeContext.Provider value={{ lotGridRows, setLotGridRows }}>
      {children}
    </HomeContext.Provider>
  );
};

const HomeConsumer = () => {
  const { lotGridRows } = useContext(HomeContext);

  return (
    <div>
      {/*Lot grid rows: {lotGridRows}*/}
    </div>
  );
};

export { HomeProvider, HomeConsumer, HomeContext };

const splitContent = (content) => {
  const sections = content.split('<section');
  return sections.map((section, index) => {
    if (index === 0) return section; // The first part before any <section> tag
    return '<section' + section; // Add back the <section> tag
  });
};